/* XUHE HAIR THEME — 全站交互（Shopify 版） */
(function () {
  "use strict";
  var prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------- 公告栏轮播 ---------- */
  var topbarMsgs = document.querySelectorAll(".topbar-msg");
  if (topbarMsgs.length > 1 && !prefersReducedMotion) {
    var ti = 0;
    setInterval(function () {
      topbarMsgs[ti].classList.remove("active");
      ti = (ti + 1) % topbarMsgs.length;
      topbarMsgs[ti].classList.add("active");
    }, 5000);
  }

  /* ---------- 移动端菜单抽屉 / 搜索 ---------- */
  var menuToggle = document.querySelector(".menu-toggle");
  var navLinks = document.querySelector(".nav-links");
  var menuBackdrop = document.querySelector(".xh-menu-backdrop");
  var menuViewport = window.matchMedia("(max-width: 1020px)");
  var searchDialog = document.querySelector(".xh-search-dialog");
  var searchReturnFocus = null;
  var menuReturnFocus = null;
  var menuPreviousOverflow = null;
  var menuAttributes = {};

  if (navLinks) {
    ["role", "aria-modal", "aria-label", "tabindex"].forEach(function (name) {
      menuAttributes[name] = navLinks.getAttribute(name);
    });
  }

  function menuIsOpen() {
    return !!(navLinks && navLinks.classList.contains("open"));
  }

  function restoreMenuAttributes() {
    if (!navLinks) return;
    Object.keys(menuAttributes).forEach(function (name) {
      if (menuAttributes[name] === null) navLinks.removeAttribute(name);
      else navLinks.setAttribute(name, menuAttributes[name]);
    });
  }

  function updateMenuTop() {
    var topbar = document.querySelector(".topbar");
    var bottom = topbar && topbar.getClientRects().length ? topbar.getBoundingClientRect().bottom : 0;
    document.documentElement.style.setProperty("--xh-menu-top", Math.max(0, bottom) + "px");
  }

  function setSubmenuExpanded(parent, expanded) {
    parent.classList.toggle("mega-open", expanded);
    parent.querySelectorAll(".mega-toggle, [data-xh-submenu-toggle]").forEach(function (toggle) {
      toggle.setAttribute("aria-expanded", String(expanded));
    });
  }

  function closeMenu(restoreFocus) {
    var wasOpen = menuIsOpen();
    if (navLinks) {
      navLinks.classList.remove("open");
      navLinks.querySelectorAll(".has-mega").forEach(function (parent) {
        setSubmenuExpanded(parent, false);
      });
      restoreMenuAttributes();
      navLinks.inert = menuViewport.matches;
    }
    if (menuToggle) menuToggle.setAttribute("aria-expanded", "false");
    if (menuBackdrop) menuBackdrop.hidden = true;
    if (menuPreviousOverflow !== null) {
      document.body.style.overflow = menuPreviousOverflow;
      menuPreviousOverflow = null;
    }
    if (wasOpen && restoreFocus !== false && menuReturnFocus && menuReturnFocus.isConnected) {
      menuReturnFocus.focus({ preventScroll: true });
    }
    menuReturnFocus = null;
  }

  function menuFocusableElements() {
    if (!navLinks) return [];
    return Array.prototype.filter.call(navLinks.querySelectorAll(
      "a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex='-1'])"
    ), function (element) {
      return element.getClientRects().length && !element.closest("[hidden], [inert]");
    });
  }

  function focusMenuStart() {
    var closeButton = navLinks.querySelector("[data-xh-menu-close]");
    var focusable = menuFocusableElements();
    if (closeButton && closeButton.getClientRects().length && !closeButton.disabled) {
      closeButton.focus({ preventScroll: true });
    } else if (focusable.length) {
      focusable[0].focus({ preventScroll: true });
    } else {
      navLinks.setAttribute("tabindex", "-1");
      navLinks.focus({ preventScroll: true });
    }
  }

  function openMenu() {
    if (!menuToggle || !navLinks || !menuViewport.matches || menuIsOpen()) return;
    if (searchDialog && searchDialog.open) searchDialog.close();
    menuReturnFocus = menuToggle;
    updateMenuTop();
    menuPreviousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    navLinks.inert = false;
    navLinks.setAttribute("role", "dialog");
    navLinks.setAttribute("aria-modal", "true");
    navLinks.setAttribute("aria-label", "Menu");
    navLinks.classList.add("open");
    menuToggle.setAttribute("aria-expanded", "true");
    if (menuBackdrop) menuBackdrop.hidden = false;
    focusMenuStart();
  }

  if (menuToggle && navLinks) {
    closeMenu(false);
    menuToggle.addEventListener("click", function () {
      if (menuIsOpen()) closeMenu();
      else openMenu();
    });
    document.querySelectorAll("[data-xh-menu-close]").forEach(function (button) {
      button.addEventListener("click", function () { closeMenu(); });
    });
    navLinks.addEventListener("click", function (event) {
      var link = event.target.closest("a[href]");
      if (link && !link.matches("[data-xh-submenu-toggle], .mega-toggle")) closeMenu();
    });
    document.addEventListener("keydown", function (event) {
      if (!menuIsOpen()) return;
      if (event.key === "Escape") {
        event.preventDefault();
        event.stopImmediatePropagation();
        closeMenu();
      } else if (event.key === "Tab") {
        var focusable = menuFocusableElements();
        if (!focusable.length) {
          event.preventDefault();
          focusMenuStart();
          return;
        }
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        var active = document.activeElement;
        if (!navLinks.contains(active) || (event.shiftKey && active === first) || (!event.shiftKey && active === last)) {
          event.preventDefault();
          (event.shiftKey ? last : first).focus({ preventScroll: true });
        }
      }
    });
    document.addEventListener("focusin", function (event) {
      if (menuIsOpen() && !navLinks.contains(event.target)) focusMenuStart();
    });
    var handleMenuViewport = function () {
      closeMenu(false);
      updateMenuTop();
    };
    if (menuViewport.addEventListener) menuViewport.addEventListener("change", handleMenuViewport);
    else menuViewport.addListener(handleMenuViewport);
    window.addEventListener("resize", function () { if (menuIsOpen()) updateMenuTop(); });
    window.addEventListener("scroll", function () { if (menuIsOpen()) updateMenuTop(); }, { passive: true });
    if (window.ResizeObserver) {
      var menuTopbar = document.querySelector(".topbar");
      if (menuTopbar) {
        var menuTopbarObserver = new ResizeObserver(function () { if (menuIsOpen()) updateMenuTop(); });
        menuTopbarObserver.observe(menuTopbar);
      }
    }
  }

  /* 移动端 Shop Hair 标题 / Mega Menu 手风琴 */
  document.querySelectorAll(".mega-toggle, .xh-mobile-menu-parent[data-xh-submenu-toggle]").forEach(function (toggle) {
    toggle.addEventListener("click", function (event) {
      if (!menuViewport.matches) return;
      var parent = toggle.closest(".has-mega");
      if (!parent) return;
      event.preventDefault();
      setSubmenuExpanded(parent, !parent.classList.contains("mega-open"));
    });
  });

  if (searchDialog) {
    document.querySelectorAll("[data-xh-search-open]").forEach(function (button) {
      button.addEventListener("click", function (event) {
        event.preventDefault();
        closeMenu(false);
        searchReturnFocus = button;
        if (!searchDialog.open) searchDialog.showModal();
        var input = searchDialog.querySelector("input[name='q']");
        if (input) input.focus({ preventScroll: true });
      });
    });
    searchDialog.querySelectorAll("[data-xh-search-close]").forEach(function (button) {
      button.addEventListener("click", function () { searchDialog.close(); });
    });
    searchDialog.addEventListener("click", function (event) {
      if (event.target !== searchDialog) return;
      var bounds = searchDialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) {
        searchDialog.close();
      }
    });
    searchDialog.addEventListener("keydown", function (event) {
      if (event.key === "Escape") event.stopPropagation();
    });
    searchDialog.addEventListener("close", function () {
      if (!menuIsOpen() && searchReturnFocus && searchReturnFocus.isConnected) {
        searchReturnFocus.focus({ preventScroll: true });
      }
      searchReturnFocus = null;
    });
  }

  /* 先释放菜单状态，再交给下方现有购物车处理。 */
  document.querySelectorAll("[data-open-cart]").forEach(function (button) {
    button.addEventListener("click", function () {
      closeMenu(false);
      if (searchDialog && searchDialog.open) searchDialog.close();
    });
  });

  /* ---------- Hero 轮播 ---------- */
  var heroCarousel = document.querySelector(".hero-carousel");
  var slides = heroCarousel ? heroCarousel.querySelectorAll(".slide") : [];
  var dots = heroCarousel ? heroCarousel.querySelectorAll(".hero-dot") : [];
  if (slides.length > 0) {
    var cur = 0;
    var timer = null;
    var heroPrev = heroCarousel.querySelector(".hero-prev");
    var heroNext = heroCarousel.querySelector(".hero-next");
    function go(n) {
      slides[cur].classList.remove("active");
      if (dots[cur]) dots[cur].classList.remove("active");
      cur = (n + slides.length) % slides.length;
      slides[cur].classList.add("active");
      if (dots[cur]) dots[cur].classList.add("active");
    }
    function auto() {
      clearInterval(timer);
      if (prefersReducedMotion || slides.length < 2) return;
      timer = setInterval(function () { go(cur + 1); }, 10000);
    }
    dots.forEach(function (dot, i) {
      dot.addEventListener("click", function () {
        go(i);
        auto();
      });
    });
    if (heroPrev) {
      heroPrev.addEventListener("click", function () {
        go(cur - 1);
        auto();
      });
    }
    if (heroNext) {
      heroNext.addEventListener("click", function () {
        go(cur + 1);
        auto();
      });
    }
    auto();
  }

  /* ---------- Toast ---------- */
  var toast = document.querySelector(".toast");
  var toastTimer = null;
  function showToast(msg) {
    if (!toast) return;
    toast.textContent = msg;
    toast.classList.add("show");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.classList.remove("show"); }, 2600);
  }
  window.xhToast = showToast;

  /* ---------- 抽屉购物车 ---------- */
  var cartDrawer = document.querySelector(".cart-drawer");
  var drawerOverlay = document.querySelector(".drawer-overlay");

  function openCart() {
    if (cartDrawer) cartDrawer.classList.add("open");
    if (drawerOverlay) drawerOverlay.classList.add("open");
    document.body.style.overflow = "hidden";
  }
  function closeCart() {
    if (cartDrawer) cartDrawer.classList.remove("open");
    if (drawerOverlay) drawerOverlay.classList.remove("open");
    document.body.style.overflow = "";
  }
  window.xhOpenCart = openCart;

  document.querySelectorAll("[data-open-cart]").forEach(function (btn) {
    btn.addEventListener("click", function (e) { e.preventDefault(); openCart(); });
  });
  document.querySelectorAll(".drawer-close, .drawer-overlay, [data-close-cart]").forEach(function (el) {
    el.addEventListener("click", closeCart);
  });


  var drawerTranslations = window.xhCartDrawerTranslations || {};

  function drawerFormatTranslation(template, values) {
    return String(template || "")
      .replace("{{ minimum }}", values.minimum == null ? "" : values.minimum)
      .replace("{{ maximum }}", values.maximum == null ? "" : values.maximum)
      .replace("{{ step }}", values.step == null ? "" : values.step)
      .replace("{{ unit }}", values.unit == null ? "" : values.unit);
  }

  var drawerCurrency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active
    ? window.Shopify.currency.active
    : "USD";
  var drawerMoneyFormatter;

  function drawerFormatMoney(cents) {
    if (!drawerMoneyFormatter) {
      try {
        drawerMoneyFormatter = new Intl.NumberFormat(document.documentElement.lang || "en-US", {
          style: "currency",
          currency: drawerCurrency
        });
      } catch (error) {
        drawerMoneyFormatter = null;
      }
    }
    return drawerMoneyFormatter
      ? drawerMoneyFormatter.format(cents / 100)
      : "$" + (cents / 100).toFixed(2);
  }

  function drawerInputs() {
    return Array.prototype.slice.call(document.querySelectorAll("[data-cart-drawer-quantity-input]"));
  }

  function drawerGroupedInputs() {
    var groups = Object.create(null);
    drawerInputs().forEach(function (input) {
      var variantId = input.getAttribute("data-variant-id") || input.getAttribute("data-line");
      if (!groups[variantId]) groups[variantId] = [];
      groups[variantId].push(input);
    });
    return Object.keys(groups).map(function (variantId) {
      return groups[variantId];
    });
  }

  function drawerGroupResult(group) {
    var first = group[0];
    var minimum = Number(first.dataset.minimum || 1);
    var step = Number(first.dataset.step || 1);
    var unit = first.dataset.unit || "items";
    var inventoryLimited = first.dataset.inventoryLimited === "true";
    var maximum = inventoryLimited ? Number(first.dataset.maximum || 0) : null;
    var total = 0;

    for (var index = 0; index < group.length; index += 1) {
      var raw = String(group[index].value || "").trim();
      var value = Number(raw);
      if (raw === "" || !Number.isFinite(value) || !Number.isInteger(value) || value < 0) {
        return { valid: false, hasItems: true, message: drawerTranslations.wholeNumber };
      }
      total += value;
    }

    if (total === 0) {
      return { valid: true, hasItems: false, message: "" };
    }
    if (first.dataset.available === "false") {
      return { valid: false, hasItems: true, message: drawerTranslations.optionUnavailable };
    }
    if (inventoryLimited && maximum < minimum) {
      return {
        valid: false,
        hasItems: true,
        message: drawerFormatTranslation(drawerTranslations.availableStockBelowMinimum, { minimum: minimum, unit: unit })
      };
    }
    if (total < minimum) {
      return {
        valid: false,
        hasItems: true,
        message: drawerFormatTranslation(drawerTranslations.minimumQuantity, { minimum: minimum, unit: unit, step: step })
      };
    }
    if ((total - minimum) % step !== 0) {
      return {
        valid: false,
        hasItems: true,
        message: drawerFormatTranslation(drawerTranslations.quantityStep, { step: step, minimum: minimum, unit: unit })
      };
    }
    if (inventoryLimited && total > maximum) {
      return {
        valid: false,
        hasItems: true,
        message: drawerFormatTranslation(drawerTranslations.maximumQuantity, { maximum: maximum, unit: unit })
      };
    }
    return { valid: true, hasItems: true, message: "" };
  }

  function drawerApplyGroupResult(group, result) {
    group.forEach(function (input) {
      var line = input.closest("[data-cart-drawer-line]");
      var error = line ? line.querySelector("[data-cart-drawer-error]") : null;
      var actions = line ? line.querySelector("[data-cart-drawer-actions]") : null;
      input.setCustomValidity(result.message || "");
      input.setAttribute("aria-invalid", result.message ? "true" : "false");
      if (error) {
        var errorMessage = error.querySelector("[data-cart-drawer-error-message]");
        if (errorMessage) {
          errorMessage.textContent = result.message || "";
        }
        error.hidden = !result.message;
      }
      if (actions) actions.hidden = result.valid || !result.hasItems;
    });
  }

  function drawerUpdateButtonStates() {
    drawerInputs().forEach(function (input) {
      var line = input.closest("[data-cart-drawer-line]");
      if (!line) return;
      var value = Number(input.value);
      var maximum = input.dataset.inventoryLimited === "true" ? Number(input.dataset.maximum || 0) : null;
      var minus = line.querySelector("[data-cart-drawer-decrease]");
      var plus = line.querySelector("[data-cart-drawer-increase]");
      if (minus) minus.disabled = !Number.isFinite(value) || value <= 0;
      if (plus) plus.disabled = maximum !== null && value >= maximum;
    });
  }

  function drawerUpdateDisplayedTotals() {
    var subtotal = 0;
    var allQuantitiesNumeric = true;
    drawerInputs().forEach(function (input) {
      var raw = String(input.value || "").trim();
      var value = Number(raw);
      var unitPrice = Number(input.dataset.unitPrice || 0);
      var line = input.closest("[data-cart-drawer-line]");
      var linePrice = line ? line.querySelector("[data-cart-drawer-line-price]") : null;
      var quantityLabel = line ? line.querySelector("[data-cart-drawer-quantity-label]") : null;

      if (raw === "" || !Number.isFinite(value) || !Number.isInteger(value) || value < 0) {
        allQuantitiesNumeric = false;
        return;
      }

      var lineTotal = Math.round(unitPrice * value);
      subtotal += lineTotal;
      if (linePrice) linePrice.textContent = drawerFormatMoney(lineTotal);
      if (quantityLabel) quantityLabel.textContent = value;
    });

    if (allQuantitiesNumeric) {
      var subtotalElement = document.querySelector("[data-cart-drawer-subtotal]");
      if (subtotalElement) subtotalElement.textContent = drawerFormatMoney(subtotal);
    }
  }

  function drawerValidate() {
    var rulesValid = true;
    var hasItems = false;
    var hasUnavailable = false;

    drawerGroupedInputs().forEach(function (group) {
      var result = drawerGroupResult(group);
      drawerApplyGroupResult(group, result);
      if (!result.valid) rulesValid = false;
      if (result.hasItems) hasItems = true;
      if (result.hasItems && group[0].dataset.available === "false") hasUnavailable = true;
    });

    var checkout = document.querySelector("[data-cart-drawer-checkout]");
    var review = document.querySelector("[data-cart-drawer-review]");
    var summary = document.querySelector("[data-cart-drawer-summary]");
    var checkoutValid = rulesValid && hasItems;
    if (checkout) {
      checkout.classList.toggle("is-disabled", !checkoutValid);
      checkout.setAttribute("aria-disabled", checkoutValid ? "false" : "true");
      checkout.tabIndex = checkoutValid ? 0 : -1;
    }
    if (review) review.hidden = checkoutValid;
    if (summary) {
      summary.hidden = checkoutValid;
      summary.textContent = hasUnavailable ? drawerTranslations.unavailableSummary : drawerTranslations.quantitySummary;
    }

    drawerUpdateDisplayedTotals();
    drawerUpdateButtonStates();
    return { rulesValid: rulesValid, hasItems: hasItems, checkoutValid: checkoutValid };
  }

  function drawerPersistQuantity(input) {
    var line = input.closest("[data-cart-drawer-line]");
    if (!line) return;

    var value = Number(input.value);
    drawerValidate();
    if (!Number.isFinite(value) || !Number.isInteger(value) || value < 0 || input.getAttribute("aria-invalid") === "true") {
      return;
    }

    var lineNumber = Number(input.dataset.line || line.dataset.line);
    var previousQuantity = Number(input.dataset.serverQuantity || 0);
    input.dataset.pending = "true";
    input.disabled = true;

    fetch(window.xhRoutes.cart_change + ".js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ line: lineNumber, quantity: value })
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) throw new Error(data.description || data.message || drawerTranslations.updateError);
          return data;
        });
      })
      .then(function (cart) {
        if (value === 0) {
          window.location.reload();
          return;
        }
        var item = cart.items && cart.items[lineNumber - 1];
        if (item) {
          input.value = item.quantity;
          input.dataset.serverQuantity = item.quantity;
          input.dataset.unitPrice = item.final_price;
          var linePrice = line.querySelector("[data-cart-drawer-line-price]");
          if (linePrice) linePrice.textContent = drawerFormatMoney(item.final_line_price);
        }
        var subtotal = document.querySelector("[data-cart-drawer-subtotal]");
        if (subtotal) subtotal.textContent = drawerFormatMoney(cart.total_price);
        var count = document.querySelector(".cart-count");
        if (count) {
          count.textContent = cart.item_count;
          count.style.display = cart.item_count > 0 ? "grid" : "none";
        }
        drawerValidate();
      })
      .catch(function (error) {
        input.value = previousQuantity;
        input.setCustomValidity(error.message);
        input.setAttribute("aria-invalid", "true");
        var errorElement = line.querySelector("[data-cart-drawer-error]");
        if (errorElement) {
          var errorMessage = errorElement.querySelector("[data-cart-drawer-error-message]");
          if (errorMessage) errorMessage.textContent = error.message;
          errorElement.hidden = false;
        }
        if (window.xhToast) window.xhToast(error.message);
        drawerValidate();
      })
      .finally(function () {
        input.disabled = false;
        delete input.dataset.pending;
        drawerUpdateButtonStates();
      });
  }

  document.querySelectorAll("[data-cart-drawer-quantity-input]").forEach(function (input) {
    input.addEventListener("input", drawerValidate);
    input.addEventListener("change", function () {
      drawerPersistQuantity(input);
    });
  });

  document.querySelectorAll("[data-cart-drawer-decrease], [data-cart-drawer-increase]").forEach(function (button) {
    button.addEventListener("click", function () {
      var input = button.closest("[data-cart-drawer-line]")?.querySelector("[data-cart-drawer-quantity-input]");
      if (!input) return;
      var current = Number(input.value) || 0;
      var minimum = Number(input.dataset.minimum || 1);
      var step = Number(input.dataset.step || 1);
      var maximum = input.dataset.inventoryLimited === "true" ? Number(input.dataset.maximum || 0) : null;
      var direction = button.hasAttribute("data-cart-drawer-increase") ? 1 : -1;
      var next = direction > 0
        ? current < minimum ? minimum : current + step
        : current <= minimum ? 0 : current - step;
      if (maximum !== null) next = Math.min(next, maximum);
      input.value = Math.max(0, next);
      input.dispatchEvent(new Event("input", { bubbles: true }));
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  });

  var drawerCheckout = document.querySelector("[data-cart-drawer-checkout]");
  if (drawerCheckout) {
    drawerCheckout.addEventListener("click", function (event) {
      var result = drawerValidate();
      if (!result.checkoutValid) {
        event.preventDefault();
        var invalid = document.querySelector("[data-cart-drawer-quantity-input][aria-invalid='true']");
        if (invalid) invalid.focus();
      }
    });
  }

  /* 删除购物车行（Shopify /cart/change.js） */
  document.querySelectorAll("[data-remove-line]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      fetch(window.xhRoutes.cart_change + ".js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ line: Number(btn.getAttribute("data-remove-line")), quantity: 0 })
      }).then(function () { window.location.reload(); });
    });
  });

  /* 购物车角标计数 */
  fetch("/cart.js").then(function (r) { return r.json(); }).then(function (c) {
    var el = document.querySelector(".cart-count");
    if (el && c.item_count > 0) {
      el.textContent = c.item_count;
      el.style.display = "grid";
    }
  }).catch(function () {});

  /* ---------- 20% 弹窗（延时 15s，每会话一次） ---------- */
  var modal = document.querySelector(".modal-overlay");
  if (modal && !sessionStorage.getItem("xh-popup-seen")) {
    setTimeout(function () {
      modal.classList.add("open");
      sessionStorage.setItem("xh-popup-seen", "1");
    }, 15000);
  }
  document.querySelectorAll(".modal-close, .modal-overlay").forEach(function (el) {
    el.addEventListener("click", function (e) {
      if (e.target === el) el.closest(".modal-overlay").classList.remove("open");
    });
  });

  /* ---------- PDP：图库切换（旧版图库兼容） ---------- */
  /* Enhanced PDP has its own button-based gallery handler. */
  if (!document.getElementById("xuhe-gallery")) {
    var galleryMain = document.querySelector(".gallery-main img");
    document.querySelectorAll(".thumb-row img").forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        if (!galleryMain) return;
        galleryMain.src = thumb.getAttribute("data-full") || thumb.src;
        document.querySelectorAll(".thumb-row img").forEach(function (t) { t.classList.remove("active"); });
        thumb.classList.add("active");
      });
    });
  }

  /* ---------- 数量步进器 ---------- */
  document.querySelectorAll(".qty-stepper").forEach(function (stepper) {
    var input = stepper.querySelector("input");
    stepper.querySelectorAll("button").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var v = parseInt(input.value, 10) || 1;
        input.value = Math.max(1, v + (btn.getAttribute("data-step") === "+" ? 1 : -1));
        input.dispatchEvent(new Event("change", { bubbles: true }));
      });
    });
  });

  /* ---------- Sticky ATC（移动端吸底） ---------- */
  var stickyAtc = document.querySelector(".sticky-atc");
  var purchaseBox = document.querySelector(".purchase-box");
  if (stickyAtc && purchaseBox) {
    stickyAtc.classList.add("active");
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        stickyAtc.classList.toggle("visible", !entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
    }, { threshold: 0 });
    observer.observe(purchaseBox);
  }

  /* ---------- 集合页：筛选抽屉（移动端） ---------- */
  var filterToggle = document.querySelector(".filter-toggle");
  var filterPanel = document.querySelector(".filter-panel");
  if (filterToggle && filterPanel) {
    filterToggle.addEventListener("click", function () {
      filterPanel.classList.toggle("open");
    });
  }

  /* 加购后自动打开抽屉 */
  if (sessionStorage.getItem("xh-open-cart")) {
    sessionStorage.removeItem("xh-open-cart");
    openCart();
  }

  /* ---------- ESC 关闭浮层 ---------- */
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
      closeCart();
      if (modal) modal.classList.remove("open");
      if (filterPanel) filterPanel.classList.remove("open");
    }
  });
})();


